// mui
import { Button, Stack, Typography } from '@mui/material';

// types
import { OrganiseEntryStatus } from '@karehero/models';

import {
  OrganiserEntryItem,
  OrganiserEntryRow,
} from '../OrganiserEntryRow/OrganiserEntryRow';

export enum EntryCategory {
  OVERDUE = 'overdue',
  UNDATED = 'undated',
  TODAY = 'today',
  THIS_WEEK = 'this_week',
  UPCOMING = 'upcoming',
}

export interface EntryGroup {
  title: string;
  category: EntryCategory;
  color?: string;
  entries?: OrganiserEntryItem[];
  isOverdue?: boolean;
  hasMore?: boolean;
  onShowMore?: () => void;
}

interface OrganiserEntryGroupProps extends EntryGroup {
  recentlyCompleted?: Set<string>;
  onStatusChange: (entryId: string, status: OrganiseEntryStatus) => void;
  onEntryClick: (entryId: string) => void;
  onEntryLinkClick?: (link: string) => void;
  /** Row + header presentation. `member` uses an overline header and the
   * carer-facing row; `admin` (default) uses the h4 header. */
  variant?: 'admin' | 'member';
}

export const OrganiserEntryGroup = ({
  title,
  color,
  entries,
  isOverdue,
  hasMore,
  recentlyCompleted,
  onShowMore,
  onStatusChange,
  onEntryClick,
  onEntryLinkClick,
  variant = 'admin',
}: OrganiserEntryGroupProps) => {
  return (
    <Stack spacing={1.25}>
      <Typography
        variant={variant === 'member' ? 'overline' : 'h4'}
        color={color}
      >
        {title}
      </Typography>
      <Stack spacing={1}>
        {entries?.map((entry) => (
          <OrganiserEntryRow
            key={entry.id}
            entry={entry}
            variant={variant}
            onStatusChange={onStatusChange}
            onEntryClick={onEntryClick}
            onEntryLinkClick={onEntryLinkClick}
            isFading={recentlyCompleted?.has(entry.id)}
            isOverdue={isOverdue}
          />
        ))}
      </Stack>
      {hasMore && (
        <Stack
          sx={{
            alignItems: 'center',
            py: 1,
          }}
        >
          <Button variant='text' onClick={onShowMore}>
            Show more
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
